let dirtyDozenData = [
	{
		id: 1,
		title: {
			en: 'Lack of Communication',
			de: 'Mangelnde Kommunikation',
			ja: 'コミュニケーションの欠如',
			pt: `Falta de comunicação`
		},
		subtitle: {
			en: 'Improve your communication',
			de: 'Verbessern Sie Ihre Kommunikation',
			ja: 'コミュニケーション改善',
			pt: `Melhore a sua comunicação`
		},
		text: {
			en: 'Failure to transmit, receive, or provide enough information to complete a task. Never assume anything.<br />Only 30% of verbal communication is received and understood by either side in a conversation. Others usually remember the first and last part of what you say.',
			de: 'Das Versäumnis, ausreichende Informationen zu übermitteln, zu erhalten oder zur Verfügung zu stellen, erschwert die Erfüllung einer Aufgabe.<br />Nur 30 % der mündlichen Kommunikation wird von beiden Seiten eines Gesprächs aufgenommen und verstanden. Andere erinnern sich in der Regel an den ersten und letzten Teil dessen, was Sie sagen.',
			ja: 'タスクを完了するのに十分な情報を発信、受信、または提供できないこと。決めつけないこと。<br />言語によるコミュニケーションのうち、会話の中でどちらか一方が受け取り、理解できるのはわずか30％です。他者は通常、あなたが言ったことの最初と最後の部分を覚えています。',
			pt: `Falha na transmissão, receção ou fornecimento de informação suficiente para executar uma tarefa. Nunca presuma nada.<br />Apenas cerca de 30% da comunicação verbal é efetivamente recebida e compreendida por cada interveniente numa conversa. As pessoas lembram-se geralmente da primeira e da última parte do que ouvem.`
		},
		bulletpoints: [
			{
				en: 'Say the most important things in the beginning and repeat them at the end.',
				de: 'Die wichtigsten Punkte sollten am Anfang gesagt und am Ende wiederholt werden.',
				ja: '一番大事なことを最初に言い、最後に繰り返す。',
				pt: `Diga os pontos mais importantes no início e repita-os no final.`
			},
			{
				en: 'Use checklists.',
				de: 'Benutzen Sie Checklisten.',
				ja: 'チェックリストを使う。',
				pt: `Utilize listas de verificação.`
			}
		]
	},
	{
		id: 2,
		title: {
			en: 'Distraction',
			de: 'Ablenkung',
			ja: '注意散漫',
			pt: `Distração`
		},
		subtitle: {
			en: 'Get back in the groove after a distraction',
			de: 'Kommen Sie nach einer Ablenkung wieder in Schwung', 
			ja: '注意を逸らされたのちに元の状態を取り戻す',
			pt: `Retome o ritmo após uma distração`
		},
		text: {
			en: 'Anything that draws your attention away from the task at hand.<br />Distractions are the #1 cause of forgetting things, including what has or has not been done in a maintenance task.',
			de: 'Alles, was von der aktuellen Aufgabe ablenkt, sollte vermieden werden.<br />Ablenkungen sind die Hauptursache für das Vergessen von Dingen, einschließlich der Ausführung einzelner Wartungsarbeiten.',
			ja: '目の前の仕事から注意をそらすようなもの。<br />注意散漫は、整備タスクで何をしたのか、していないのかを含めて、物事を忘れることの原因の第1位です。',
			pt: `Tudo o que desvie a sua atenção da tarefa em curso.<br />As distrações são a principal causa de esquecimentos, incluindo o que foi ou não feito numa tarefa de manutenção.`
		},
		bulletpoints: [
			{
				en: 'Use checklists.',
				de: 'Benutzen Sie Checklisten.',
				ja: 'チエックリストを使う。',
				pt: `Utilize listas de verificação.`
			},
			{
				en: 'Go back 3 steps when restarting the work.',
				de: 'Gehen Sie 3 Schritte zurück, wenn Sie die Arbeit wieder aufnehmen.',
				ja: '作業再開時には手順を３ステップ戻る。',
				pt: `Ao reiniciar o trabalho, volte atrás 3 passos.`
			}
		]
	},
	{
		id: 3,
		title: {
			en: 'Lack of Resources',
			de: 'Mangel an Ressourcen',
			ja: 'リソースの欠如',
			pt: `Falta de recursos`
		},
		subtitle: {
			en: 'Improve supply and support',
			de: 'Verbessern Sie die Versorgung und Unterstützung',
			ja: '供給と支援の改善',
			pt: `Melhore o fornecimento e o apoio`
		},
		text: {
			en: 'Not having enough people, equipment, documentation, time, parts, etc., to complete a task.',
			de: 'Es gibt nicht genügend Personal, Ausrüstung, Dokumentation, Zeit oder Teile, um die Aufgabe zu erledigen.',
			ja: 'タスクを完了するために十分な人、機器、文書、時間、部品などがないこと。',
			pt: `Falta de pessoal, equipamento, documentação, tempo, peças, etc., para executar uma tarefa.`
		},
		bulletpoints: [
			{
				en: 'Order parts before they are required.',
				de: 'Bestellen Sie Teile, bevor sie benötigt werden.',
				ja: '部品が必要になる前に注文する。',
				pt: `Encomende as peças antes de serem necessárias.`
			},
			{
				en: 'Have a plan for pooling or loaning parts.',
				de: 'Erstellen Sie einen Plan, um Teile gemeinschaftlich zu nutzen oder auszuleihen.',
				ja: '部品のプールや貸し出しの計画をする。',
				pt: `Tenha um plano para partilha ou empréstimo de peças.`
			}
		]
	},
	{
		id: 4,
		title: {
			en: 'Stress',
			de: 'Stress',
			ja: 'ストレス',
			pt: `Stress`
		},
		subtitle: {
			en: 'Manage stress before it affects your work',
			de: 'Bewältigen Sie Stress, bevor er ihre Arbeit beeinträchtigt',
			ja: '仕事に影響が出る前にストレスを管理する',
			pt: `Controle o stress antes de afetar o seu trabalho`
		},
		text: {
			en: 'A physical, chemical, or emotional factor that causes physical or mental tension.',
			de: 'Ein physischer, chemischer oder emotionaler Faktor, der körperliche oder geistige Anspannung verursacht.',
			ja: '身体的、化学的、または感情的な要因で、身体的または精神的な緊張を引き起こすもの。',
			pt: `Um fator físico, químico ou emocional que causa tensão física ou mental.`
		},
		bulletpoints: [
			{
				en: 'Take a rational approach to problem solving.',
				de: 'Gehen Sie bei der Problemlösung rational vor.',
				ja: '問題解決に合理的なアプローチをとる。',
				pt: `Adote uma abordagem racional à resolução de problemas.`
			},
			{
				en: 'Take a short break when needed.',
				de: 'Machen Sie bei Bedarf eine kurze Pause.',
				ja: '必要なときは少し休憩する。',
				pt: `Faça uma pequena pausa quando necessário.`
			},
			{
				en: 'Discuss the problem with someone who can help.',
				de: 'Besprechen Sie das Problem mit jemandem, der helfen kann.',
				ja: '相談できる人に相談する。',
				pt: `Fale sobre o problema com alguém que possa ajudar.`
			}
		]
	},
	{
		id: 5,
		title: {
			en: 'Complacency',
			de: 'Selbstgefälligkeit',
			ja: '自己満足',
			pt: `Complacência`
		},
		subtitle: {
			en: 'Avoid the tendency to see what you expect to see',
			de: 'Vermeiden Sie die Tendenz, das zu sehen, was Sie erwarten zu sehen',
			ja: '期待するものを見てしまう傾向を避ける',
			pt: `Evite a tendência de ver o que espera ver`
		},
		text: {
			en: 'Overconfidence from repeated experience performing a task.',
			de: 'Selbstüberschätzung aufgrund wiederholter Ausführung einer Aufgabe.',
			ja: '同じ作業を繰り返し経験することで得られる過信。',
			pt: `Excesso de confiança resultante da repetição de uma tarefa.`
		},
		bulletpoints: [
			{
				en: 'Expect to find errors.',
				de: 'Rechnen Sie damit, Fehler zu finden.',
				ja: 'エラーを見つけることを期する。',
				pt: `Espere encontrar erros.`
			},
			{
				en: 'Don\'t sign it if you did not do it.',
				de: 'Unterschreiben Sie nicht, wenn Sie es nicht getan haben.',
				ja: 'やっていないなら署名しない。',
				pt: `Não assine se não executou a tarefa.`
			},
			{
				en: 'Use checklists.',
				de: 'Verwenden Sie Checklisten.',
				ja: 'チェックリストを使用する。',
				pt: `Utilize listas de verificação.`
			},
			{
				en: 'Learn from the mistakes of others.',
				de: 'Lernen Sie aus den Fehlern der anderen.',
				ja: '他の人のミスから学ぶ。',
				pt: `Aprenda com os erros dos outros.`
			}
		]
	},
	{
		id: 6,
		title: {
			en: 'Lack of Teamwork',
			de: 'Mangelnde Teamarbeit',
			ja: 'チームワークの欠如',
			pt: `Falta de trabalho em equipa`
		},
		subtitle: {
			en: 'Build solid teamwork',
			de: 'Bauen Sie solide Teamarbeit auf',
			ja: '強固なチームワークを築く',
			pt: `Promova um trabalho de equipa sólido`
		},
		text: {
			en: 'Failure to work together to complete a shared goal.',
			de: 'Das Scheitern an der Zusammenarbeit, um ein gemeinsames Ziel zu erreichen.',
			ja: '共通の目標を達成するために協力し合うことができないこと。',
			pt: `Falha em trabalhar em conjunto para atingir um objetivo comum.`
		},
		bulletpoints: [
			{
				en: 'Discuss how a task should be done.',
				de: 'Besprechen Sie gemeinsam, wie eine Aufgabe erledigt werden soll.',
				ja: 'ある仕事の進め方について話し合う。',
				pt: `Discuta como uma tarefa deve ser realizada.`
			},
			{
				en: 'Make sure everyone understands and agrees.',
				de: 'Vergewissern Sie sich, dass alle zustimmen und es verstehen.',
				ja: '全員が理解し、同意していることを確認する。',
				pt: `Certifique-se de que todos compreendem e concordam.`
			},
			{
				en: 'Trust your teammates.',
				de: 'Vertrauen Sie Ihren Teamkollegen.',
				ja: 'チームメイトを信頼する。',
				pt: `Confie nos seus colegas de equipa.`
			}
		]
	},
	{
		id: 7,
		title: {
			en: 'Pressure',
			de: 'Druck',
			ja: 'プレッシャー',
			pt: `Pressão`
		},
		subtitle: {
			en: 'Reduce the burden of physical or mental distress',
			de: 'Verringern Sie den Druck durch körperliche oder seelische Probleme',
			ja: '身体的または精神的苦痛の負担を軽減する',
			pt: `Reduza a pressão física ou mental`
		},
		text: {
			en: 'Real or perceived forces demanding high-level job performance.',
			de: 'Gesteigerte Arbeitsleistung ausgelöst durch tatsächliche oder empfundene Zwänge.', 
			ja: '高度な職務遂行を要求する現実の力、または認識された力。',
			pt: `Forças reais ou percebidas que exigem um elevado nível de desempenho no trabalho.`
		},
		bulletpoints: [
			{
				en: 'Communicate concerns.',
				de: 'Kommunizieren Sie Ihre Bedenken.',
				ja: '懸念を伝える。',
				pt: `Comunique as suas preocupações.`
			},
			{
				en: 'Ask for extra help.',
				de: 'Bitten Sie um zusätzliche Hilfe.',
				ja: '更なる助けを求める。',
				pt: `Peça ajuda extra.`
			},
			{
				en: 'Put safety first.',
				de: 'Sicherheit steht an erster Stelle.',
				ja: '安全を第一に考える。',
				pt: `Dê prioridade à segurança.`
			}
		]
	},
	{
		id: 8,
		title: {
			en: 'Lack of Awareness',
			de: 'Mangelnde Wahrnehmung',
			ja: '認識不足',
			pt: `Falta de consciência situacional`
		},
		subtitle: {
			en: 'See the whole picture',
			de: 'Sehen Sie das große Ganze',
			ja: '全体像をみる',
			pt: `Tenha uma visão global`
		},
		text: {
			en: 'Failure to recognize a situation, understand what it is, and predict the possible results.',
			de: 'Das Scheitern, eine Situation zu erkennen und die möglichen Folgen vorherzusagen.',
			ja: '状況を認識し、それが何であるかを理解し、起こりうる結果を予測することの失敗。',
			pt: `Incapacidade de reconhecer uma situação, compreendê-la e prever os possíveis resultados.`
		},
		bulletpoints: [
			{
				en: 'Make sure there are no conflicts with an existing repair or modifications.',
				de: 'Vergewissern Sie sich, dass es keine Probleme mit einer bestehenden Reparatur oder Modifikation gibt.',
				ja: '既存の修理や改造と矛盾がないことを確認する。',
				pt: `Certifique-se de que não existem conflitos com reparações ou modificações já existentes.`
			},
			{
				en: 'Fully understand the procedures needed to complete a task.',
				de: 'Verstehen Sie die für die Ausführung einer Aufgabe erforderlichen Verfahren vollständig.',
				ja: '作業を完了するために必要な手順を完全に理解する。',
				pt: `Compreenda completamente os procedimentos necessários para executar uma tarefa.`
			}
		]
	},
	{
		id: 9,
		title: {
			en: 'Lack of Knowledge',
			de: 'Mangelndes Wissen',
			ja: '知識不足',
			pt: `Falta de conhecimento`
		},
		subtitle: {
			en: 'Don’t guess, know',
			de: 'Raten Sie nicht, wissen Sie',
			ja: '推測するのではなく、知る',
			pt: `Não adivinhe, saiba`
		},
		text: {
			en: 'Shortage of the training, information, and/or ability to successfully perform.',
			de: 'Mangel an Ausbildung, Informationen und/oder der Fähigkeiten zur erfolgreichen Durchführung.',
			ja: '成功裏に遂行するための訓練、情報、および/または能力の不足。',
			pt: `Falta de formação, de informação e/ou de capacidade para executar uma tarefa com sucesso.`
		},
		bulletpoints: [
			{
				en: 'Use current manuals.',
				de: 'Benutzen Sie die aktuellen Handbücher.',
				ja: '最新のマニュアルを使う。',
				pt: `Utilize manuais atualizados.`
			},
			{
				en: 'Ask when you do not know.',
				de: 'Fragen Sie, wenn Sie etwas nicht wissen.',
				ja: 'わからないことは聞く。',
				pt: `Pergunte quando não souber.`
			},
			{
				en: 'Participate in training.',
				de: 'Nehmen Sie an Trainings teil.',
				ja: 'トレーニングに参加する。',
				pt: `Participe em formações.`
			}
		]
	},
	{
		id: 10,
		title: {
			en: 'Fatigue',
			de: 'Müdigkeit',
			ja: '疲労',
			pt: `Fadiga`
		},
		subtitle: {
			en: 'Eliminate fatigue related performance issues',
			de: 'Vermeiden Sie ermüdungsbedingte Leistungsprobleme',
			ja: '疲労によるパフォーマンスの低下を解消',
			pt: `Elimine problemas de desempenho relacionados com a fadiga`
		},
		text: {
			en: 'Physical or mental exhaustion threatening work performance.',
			de: 'Körperliche oder geistige Erschöpfung, die die Arbeitsleistung gefährdet.',
			ja: '肉体的または精神的な疲労が仕事のパフォーマンスを脅かす。',
			pt: `Exaustão física ou mental que ameaça o desempenho no trabalho.`
		},
		bulletpoints: [
			{
				en: 'Watch for symptoms of fatigue in yourself and others.',
				de: 'Achten Sie auf Ermüdungserscheinungen bei sich und anderen.',
				ja: '自分や他人の疲労の症状に気をつける。',
				pt: `Observe os sintomas de fadiga em si próprio e nos outros.`
			},
			{
				en: 'Have others check your work.',
				de: 'Lassen Sie Ihre Arbeit von anderen überprüfen.',
				ja: '自分の仕事を他の人にチェックしてもらう。',
				pt: `Peça a outros que verifiquem o seu trabalho.`
			}
		]
	},
	{
		id: 11,
		title: {
			en: 'Lack of Assertiveness',
			de: 'Mangelndes Durchsetzungsvermögen',
			ja: 'アサーティブネスの欠如',
			pt: `Falta de assertividade`
		},
		subtitle: {
			en: 'Express your feelings, opinions, beliefs, and needs in a positive, productive manner',
			de: 'Bringen Sie ihre Gefühle, Meinungen, Überzeugungen und Bedürfnisse auf positive Weise zum Ausdruck',
			ja: '自分の気持ち、意見、信念、ニーズを、肯定的かつ生産的に表現する',
			pt: `Expresse os seus sentimentos, opiniões, crenças e necessidades de forma positiva e produtiva`
		},
		text: {
			en: 'Failure to speak up or document concerns about instructions, orders, or the actions of others.',
			de: 'Das Versäumnis, Bedenken gegen Anweisungen, Hinweise oder Handlungen anderer zu äußern oder zu dokumentieren.',
			ja: '指示、命令、他者の行動に関する懸念を口にしなかったり、文書化しなかったりすること。',
			pt: `Falha em manifestar ou documentar preocupações sobre instruções, ordens ou ações de outros.`
		},
		bulletpoints: [
			{
				en: 'Express concerns but offer positive solutions.',
				de: 'Äußern Sie Ihre Bedenken, aber bieten Sie positive Lösungen an.',
				ja: '懸念を表明しつつも、前向きな解決策を提示する。',
				pt: `Expresse as suas preocupações e proponha soluções positivas.`
			},
			{
				en: 'Resolve one issue before addressing another.',
				de: 'Äußern Sie Ihre Bedenken, aber bieten Sie positive Lösungen an.',
				ja: '一つの問題を解決してから、別の問題に対処する。',
				pt: `Resolva um problema antes de abordar outro.`
			}
		]
	},
	{
		id: 12,
		title: {
			en: 'Norms',
			de: 'Normen',
			ja: '規範となるもの',
			pt: `Normas`
		},
		subtitle: {
			en: 'Help maintain a positive environment with your good attitude and work habits',
			de: 'Tragen Sie mit einer guten Einstellung und Ihren Arbeitsgewohnheiten dazu bei, ein positives Umfeld zu schaffen',
			ja: '良い態度と仕事の習慣で、ポジティブな環境の維持に貢献する',
			pt: `Ajude a manter um ambiente positivo com uma atitude positiva e bons hábitos de trabalho`
		},
		text: {
			en: 'Expected, yet unwritten, rules of behaviour.',
			de: 'Ungeschriebene, aber erwartete Verhaltensregeln.',
			ja: '期待されている、しかし明文化されていない、行動のルール。',
			pt: `Regras de comportamento esperadas, mas não formalmente estabelecidas.`
		},
		bulletpoints: [
			{
				en: 'Existing norms do not make procedures right.',
				de: 'Bestehende Normen sind nicht automatisch die richtigen Verfahren.',
				ja: '既存の規範が正しい手順というわけではない。',
				pt: `As normas existentes não tornam os procedimentos corretos.`
			},
			{
				en: 'Follow good safety procedures.',
				de: 'Befolgen Sie gute Sicherheitsverfahren.',
				ja: '正しい安全手順に従う。',
				pt: `Siga procedimentos de segurança adequados.`
			},
			{
				en: 'Identify and eliminate negative norms.',
				de: 'Identifizieren und beseitigen Sie negative Normen.',
				ja: 'ネガティブな規範を特定し、排除する。',
				pt: `Identifique e elimine normas negativas.`
			}
		]
	}
];

module.exports = {dirtyDozenData};